import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=2add5ea1&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=2add5ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add5ea1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2add5ea1')) {
      api.createRecord('2add5ea1', component.options)
    } else {
      api.reload('2add5ea1', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=2add5ea1&scoped=true&", function () {
      api.rerender('2add5ea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YoILXyPla7QI/JS/comp/DateRangeExt.vue"
export default component.exports